import { render, staticRenderFns } from "./newdel.vue?vue&type=template&id=3d049e04&scoped=true"
import script from "./newdel.vue?vue&type=script&lang=js"
export * from "./newdel.vue?vue&type=script&lang=js"
import style0 from "./newdel.vue?vue&type=style&index=0&id=3d049e04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d049e04",
  null
  
)

export default component.exports